import React, {PropsWithChildren, useEffect, useState} from "react";
import {IStandardDialogRenderer} from "../../services/dialog/dialog.service.interface";
import {observer} from "mobx-react";
import ReactModal, {Styles as ReactModalStyles} from "react-modal";
import {useServices} from "../../hooks/use-services.hook";
import {getCommonModalContentStyles, getCommonModalOverlayStyles} from "./common-modal-content-styles";
import {IServiceFactory} from "../../services/service-factory.interface";

interface StandardModalDialogComponentProps extends PropsWithChildren {
    renderer: IStandardDialogRenderer;
}

export const StandardDialogComponent: React.FC<StandardModalDialogComponentProps> = observer((props) => {
    const services = useServices();
    const [isAnimated, setIsAnimated] = useState(false);

    useEffect(() => {
        setIsAnimated(true);
    }, []);

    const positioning = computePositioning(services);

    const styles: ReactModalStyles = {
        content: {
            ...getCommonModalContentStyles(),
            ...positioning,
            transition: 'top 0.2s ease-in-out',
            top: isAnimated ? positioning.top : '100%',
        },
        overlay: {
            ...getCommonModalOverlayStyles(services)
        }
    }

    const captureElementRef = (element: any) => {
        props.renderer.attachElementRef(element)
    }

    //forceFullScreen={props.renderer.forceFullScreenOnLargeScreens}
    return (
        <ReactModal key={props.renderer.id}
                    id={props.renderer.id}
                    ref={captureElementRef}
                    isOpen={props.renderer.isOpen}
                    style={styles}
                    onAfterOpen={() => props.renderer.onDidPresent()}>
            {props.children}
        </ReactModal>
    )
});

function computePositioning(services: IServiceFactory): React.CSSProperties {
    if(services.screenMediaQuery.sAndBelow) {
        return {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        }
    }
    if(services.screenMediaQuery.mAndBelow) {
        return {
            top: '15%',
            bottom: '15%',
            left: '10%',
            right: '10%'
        }
    }

    if(services.screenMediaQuery.lAndBelow) {
        return {
            top: '15%',
            bottom: '15%',
            left: '15%',
            right: '15%'
        }
    }

    return {
        top: '20%',
        bottom: '20%',
        left: '25%',
        right: '25%'
    }

}